import React from "react";
import styles from "./product_in_order.module.css";
import { Link, useLocation } from "react-router-dom";

const ProductInOrder = ({ productsinorder_set }) => {

  const location = useLocation();

  return (
    <ul className={styles.list}>
      {productsinorder_set.map((item, index) => {
        return (
          <li className={styles.item} key={index}>
            <div className={styles.item__name}>
              <Link to={item.product.path} className={styles.link}
                target="_blank" rel="noreferrer"
              >
                {item.product.name}
              </Link>
            </div>
            <div className={styles.item__quantity}>
              <p className={styles.text}>{item.quantity_all}</p>
              {location.pathname === '/new_order' && (item.product.available_count < item.quantity_all) &&
                <p className={styles.text}>
                  ({item.quantity_all - item.product.available_count} под заказ)
                </p>
              }
              {item.quantity_pending > 0 &&
                <p className={styles.text}>
                  ({item.quantity_pending} под заказ)
                </p>
              }
            </div>
            <div className={styles.item__char}>
              <p className={styles.text}>х</p>
            </div>
            <div className={styles.item__price}>
              <p className={styles.text}>{item.price.toLocaleString()}  &#8381;</p>
            </div>
            <div className={styles.item__char}>
              <p className={styles.text}>=</p>
            </div>
            <div className={styles.item__sum}>
              <p className={styles.text}>{(item.quantity_all * item.price).toLocaleString()}  &#8381;</p>
            </div>
          </li>
        )
      })}
      <li className={styles.item} >
        <div className={styles.item__name}>
          <p className={styles.total_header}>Итого</p>
        </div>
        <div className={styles.item__quantity}>
          <p className={styles.text}></p>
        </div>
        <div className={styles.item__char}>
          <p className={styles.text}></p>
        </div>
        <div className={styles.item__price}>
          <p className={styles.text}></p>
        </div>
        <div className={styles.item__char}>
          <p className={styles.text}></p>
        </div>
        <div className={styles.item__sum}>
          <p className={styles.text__total}>
            {productsinorder_set.reduce((acc, item) => { return acc + item.quantity_all * item.price }, 0).toLocaleString()}  &#8381;
          </p>
        </div>
      </li>
    </ul>
  )
}

export default ProductInOrder;
